/**
 * Text emoticon → emoji conversion.
 * Only replaces tokens that are surrounded by whitespace (or at start/end of string),
 * so emoticons embedded inside words (e.g. "abc:)") are left untouched.
 */
const EMOTICON_MAP = {
  ':-)': '😊',
  ':)': '😊',
  ':-D': '😄',
  ':D': '😄',
  ':-(': '😢',
  ':(': '😢',
  ';-)': '😉',
  ';)': '😉',
  ':-P': '😛',
  ':P': '😛',
  ':-p': '😛',
  ':p': '😛',
  '<3': '❤️',
  ':-*': '😘',
  ':*': '😘',
  ':-O': '😮',
  ':O': '😮',
  ':-o': '😮',
  ':o': '😮',
  ':-/': '😕',
  ':/': '😕',
  ":'(": '😭',
  'XD': '😆',
  'xD': '😆',
  '^_^': '😊',
  '>:(': '😠',
  '>:)': '😈',
  '8-)': '😎',
  '8)': '😎',
  '|-)': '😴',
  ':3': '😸',
};

// Pre-sort descending by length so longer patterns (e.g. ":-)") match before shorter ones (":)")
const SORTED_ENTRIES = Object.entries(EMOTICON_MAP).sort((a, b) => b[0].length - a[0].length);

/**
 * Convert text emoticons to emoji.
 * Splits text on whitespace, checks each token against the emoticon map.
 * @param {string} text
 * @returns {string}
 */
export function convertEmoticons(text) {
  if (!text) return text;
  // Split preserving whitespace groups so we can rejoin perfectly
  return text.split(/(\s+)/).map(token => {
    const match = SORTED_ENTRIES.find(([emoticon]) => emoticon === token);
    return match ? match[1] : token;
  }).join('');
}
